export default __webpack_public_path__ + "static/media/ForwardVectorDark.45e3f8f3.svg";